module.exports = __webpack_public_path__ + "img/200AUD.63f156f1.png";